import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Route, Router, RouterStateSnapshot } from '@angular/router';
import { RoutePath } from 'src/app/common/constant/route-path';
import { AuthenticationService } from '../authentication.service';

@Injectable({
  providedIn: 'root'
})
export class LoginGuardService  {
  constructor(
    private authenticationService: AuthenticationService,
    private router: Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.authenticationService.loggedIn) {
      return true;
    } else {
      this.router.navigate([RoutePath.Login], {
        queryParams: {
          return: state.url
        }
      });
      return false;
    }
  }

  public secureRoute(guards: Array<string> | undefined = undefined): boolean {
    const allGuards = guards ?? [this.constructor.name]
    const url = this.router.url.startsWith('/') ? this.router.url.substring(1) : this.router.url
    const currentRouteConfig: Route | undefined = this.router.config.find(currentRoute => currentRoute.path === url);
    if (!currentRouteConfig?.canActivate) return false

    return Array.isArray(currentRouteConfig.canActivate) && (<Array<CanActivateFn>>currentRouteConfig.canActivate).some(item => allGuards.includes(item.name))
  }
}
